import React from "react";
import type { TenantConfiguration } from "./tenantsConfigurations";

export const TenantContext = React.createContext<TenantConfiguration>(
  undefined!
);
